import { Directive, OnInit, HostListener } from '@angular/core';
import { NgControl } from '@angular/forms';
import { maskPhone, removeNonDigits } from './mask-util';

@Directive({
  selector: '[formControlName][appPhoneMask]',
})
export class PhoneMaskDirective implements OnInit {

  constructor(public ngControl: NgControl) { }

  ngOnInit() {
  }

  @HostListener('input', ['$event'])
  onInputEvent(event: InputEvent) {
    this.updateControlAndDomValues(event, (event.target as HTMLInputElement).value);
  }

  private updateControlAndDomValues(event: InputEvent, newPhoneValue: string) {
    newPhoneValue = newPhoneValue || '';
    // When area code is being deleted, need to handle ) properly
    if (newPhoneValue.length === 5 && event.inputType === 'deleteContentBackward') {
      newPhoneValue = newPhoneValue.substring(0, 3);
    }
    let domValue = removeNonDigits(newPhoneValue);
    if (domValue.length === 0) {
      domValue = '';
    } else if (domValue.length <= 2) {
      domValue = domValue.replace(/^(\d{0,3})/, '($1');
    } else if (domValue.length <= 6) {
      domValue = domValue.replace(/^(\d{0,3})(\d{0,3})/, '($1) $2');
    } else if (domValue.length <= 10) {
      domValue = maskPhone(domValue);
    } else {
      if (domValue.startsWith('1')) {
        // If the number starts with '1', we want to truncate it first
        domValue = domValue.substring(1);
      }
      domValue = maskPhone(domValue);
    }
    const controlValue = removeNonDigits(domValue);
    if (this.ngControl.control.value !== controlValue) {
      this.ngControl.control.setValue(controlValue);
      this.ngControl.control.markAsDirty({ onlySelf: true });
    }

    this.ngControl.valueAccessor.writeValue(domValue);
    if (event) {
      (event.target as HTMLInputElement).value = domValue;
    }
  }
}
